import { nextPowerOfTwo, pickScore, seedingOrder } from "./utils";

export function simulateBracketResults(ids: string[]): { round: number; pos: number; winner: 1|2; score: string }[] {
  const size = nextPowerOfTwo(ids.length);
  const order = seedingOrder(size);
  const slotSeed = Array<number>(size).fill(Number.POSITIVE_INFINITY);
  for (let s=1; s<=ids.length; s++) {
    const slot = order.indexOf(s);
    slotSeed[slot] = s;
  }
  const out: { round: number; pos: number; winner: 1|2; score: string }[] = [];
  let current = slotSeed.slice();
  const rounds = Math.log2(size);
  for (let r=1; r<=rounds; r++) {
    const next: number[] = [];
    const count = size >> r;
    for (let i=0;i<count;i++) {
      const a = current[2*i];
      const b = current[2*i+1];
      if (a === Infinity && b === Infinity) { next.push(Infinity); continue; }
      if (a !== Infinity && b === Infinity) { next.push(a); out.push({ round: r, pos: i, winner: 1, score: pickScore(i + r) }); continue; }
      if (a === Infinity && b !== Infinity) { next.push(b); out.push({ round: r, pos: i, winner: 2, score: pickScore(i + r) }); continue; }
      const topWins = a < b;
      next.push(topWins ? a : b);
      out.push({ round: r, pos: i, winner: topWins ? 1 : 2, score: pickScore(i + r) });
    }
    current = next;
  }
  return out;
}


